/**
 * Serialize a form to queryString
 *
 * @param {element} form
 */
export function serialize(form, isForm = true) {
  let url = ""
  if (isForm) {
    const formData = new FormData(form)
    url = [...formData.entries()]
      .reduce((acc, curr) => {
        const existing = acc.find(x => x.key === curr[0])
        if (existing) {
          existing.value = existing.value + "," + curr[1]
        } else {
          acc.push({ key: curr[0], value: curr[1] })
        }
        return acc
      }, [])
      .map(x => `${encodeURIComponent(x.key)}=${encodeURIComponent(x.value)}`)
      .join("&")
  } else {
    url = Object.keys(form)
      .map(key =>
        Array.isArray(form[key])
          ? form[key].map(v => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`).join("&")
          : `${encodeURIComponent(key)}=${encodeURIComponent(form[key])}`
      )
      .join("&")
  }
  return url
}

/**
 * Populate a form's inputs with specified data
 *
 * @param {element} form DOM element
 * @param {URLSearchParams} urlSearchParams object
 */
export function populate(form, props) {
  // eslint-disable-next-line compat/compat
  let elements = Array.from(form.elements)

  elements.forEach(element => {
    switch (element.type) {
      case "date": {
        element.value = props[element.name] || null
        break
      }
      case "radio": {
        element.checked = element.value == props[element.name]
        break
      }
      case "select-multiple": {
        // standard html control
        const selectedValues = props[element.name] || []
        element.querySelectorAll("option").forEach(option => {
          option.selected = selectedValues.includes(option.value)
        })
        // fancy selectr dropdowns
        if (element.selectr) {
          element.selectr.eventsDisabled = true
          element.selectr.clear()
          element.selectr.setValue(selectedValues)
          element.selectr.eventsDisabled = false
        }
        break
      }
      default: {
        element.value = props[element.name] || element.value
        break
      }
    }
  })
}

/**
 * Convert specified queryString to a json object
 *
 * @param {string} queryString
 */
export function queryStringToProps(queryString) {
  const props = {}
  // eslint-disable-next-line compat/compat
  const urlParams = new URLSearchParams(queryString)

  urlParams.forEach((value, key) => {
    props[key] = value
  })

  return props
}

export function getDates(date) {
  const nd = date.split("/").map(a => parseInt(a))
  return new Date(nd[2], nd[1] - 1, nd[0])
}

export default { serialize, populate, queryStringToProps, getDates }
